<template>
  <div
    class="content-start border-2 border-black rounded-xl p-3 flex flex-col lg:flex-row home-vips-item bg-white"
    :class="{ '!flex-col': alwaysMobile }"
  >
    <div :class="{ 'lg:w-2/5 lg:order-1 lg:pr-4': !alwaysMobile }">
      <Link
        class="relative w-full h-full block"
        :href="localeRoute('frontend.vips.show', vip.username)"
      >
        <img
          v-if="vip.content.image"
          :src="vip.content.image.url"
          :alt="vip.content.display_name"
          class="rounded-lg w-full"
          loading="lazy"
          :width="alwaysMobile ? '263' : '218'"
          :height="alwaysMobile ? '263' : '218'"
        >
        <span
          v-if="!vip.content.available"
          class="bg-black/50 absolute z-20 left-0 right-0 top-0 bottom-0 rounded-lg text-white"
        />
        <span
          v-if="!vip.content.available"
          class="text-white block text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"
        >
          {{ __('general.unavailable') }}
        </span>
      </Link>
    </div>

    <div
      class="flex grow flex-col w-full mt-1"
      :class="{ 'lg:w-3/5 lg:order-2': !alwaysMobile }"
    >
      <Link
        :href="localeRoute('frontend.vips.show', vip.username)"
        class="text-lg text-red font-bold block w-full hover:underline lg:text-3xl break-words order-2"
        :class="{ 'lg:order-2 !lg:text-4xl lg:border-b lg:border-b-gray-300 lg:pb-2': !alwaysMobile }"
      >
        {{ vip.content.display_name }}
      </Link>

      <div
        class="lg:grow lg:order-3 lg:pt-4 mb-0"
      >
        <span
          v-if="vip.content.tag_line"
          class="text-black font-bold line-clamp-1"
        >
          {{ vip.content.tag_line }}
        </span>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="!alwaysMobile"
          class="hidden lg:block text-black lg:line-clamp-3 text-xs"
          v-html="vip.content.about"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>

      <span
        class="flex grow items-end text-xs font-bold block text-gray-400 lg:text-xl order-3"
        :class="{ 'lg:order-1 !lg:text-base lg:pb-2': !alwaysMobile }"
      >
        &euro; {{ vip.content.price / 100 }}
      </span>

      <div
        class="flex flex-wrap mt-2 order-1 lg:order-4"
        :class="{ 'lg:w-full': !alwaysMobile }"
      >
        <span
          v-if="vip.is_new"
          class="text-xxs border border-red text-red rounded-md py-1 px-2 mb-1 mr-1"
        >
          {{ __('general.tags.new') }}
        </span>
        <span
          v-if="vip.content.offers_48h"
          class="text-xxs border text-red border-red rounded-md py-1 px-2 mb-1 mr-1"
        >
          {{ __('general.tags.48hr') }}
        </span>
        <Link
          v-for="(category, i) in vip.content.categories"
          :key="`vip-${vip.username}-category-${i}`"
          class="text-xxs text-gray-300 border border-gray-300 rounded-md py-1 px-2 mb-1 mr-1"
          :href="localeRoute('frontend.categories.slug', [category.slug])"
        >
          {{ category.name }}
        </Link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vip: {
      type: Object,
      required: true,
    },

    alwaysMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
